import {getMobileOS} from '/util/web/deviceDetection.util';

const IOS_STORE_URL =
  'https://apps.apple.com/us/app/optavia-coach/id1518841061';
const ANDROID_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.optaviaconnect';
const APP_SCHEME = 'optaviacoach://';

export const openNativeApp = () => {
  const os = getMobileOS();

  if (os === 'android') {
    const intentUrl = `intent://#Intent;scheme=optaviacoach;package=com.optaviaconnect;S.browser_fallback_url=${encodeURIComponent(
      ANDROID_STORE_URL,
    )};end`;
    window.location.href = intentUrl;
  } else if (os === 'ios') {
    const start = Date.now();
    window.location.href = APP_SCHEME;

    setTimeout(() => {
      if (Date.now() - start < 2000) {
        window.location.href = IOS_STORE_URL;
      }
    }, 1500);
  }
};
